import React from 'react';

// Components
import { PythonDoc } from "components/api";

export function Pyhectiqlab({ children }){
  return <PythonDoc.Content name={"pyhectiqlab"}>
          {children}
          </PythonDoc.Content>
}

export function PyhectiqlabDownloadArtifact(){
  const params = [
  { 
    name: "artifact_uuid", 
    type: "str", 
    description: "Unique artifact id. Available with the web application."
  },
  { 
    name: "save_path", 
    type: "str", 
    default: "./", 
    description: "Save path."
  }
  ]
  return <div>
          <PythonDoc.Head name="pyhectiqlab.utils.download_run_artifact" params={params}>
            Download an existing artifact.
          </PythonDoc.Head>
          <PythonDoc.Params params={params}/>
         </div>
}

export function PyhectiqlabDownloadDataset(){
  const params = [
  { 
    name: "dataset_name", 
    type: "str", 
    description: "Dataset name"
  },
  { 
    name: "project", 
    type: "str", 
    description: "Project name"
  },
  { 
    name: "version", 
    type: "str", 
    description: "Specific version of the dataset. If <code>None</code>, the latest version is fetched. "
  },
  { 
    name: "save_path", 
    type: "str", 
    default: "./", 
    description: "Save path."
  },
  { 
    name: "overwrite", 
    type: "str", 
    default: "False", 
    description: "Set to <code>True</code> if you want to download the dataset again even if it is already saved on your machine."
  }
  ]
  return <div>
          <PythonDoc.Head name="pyhectiqlab.datasets.download_dataset" params={params}>
Download an existing dataset without a run context.
          </PythonDoc.Head>
          <PythonDoc.Params params={params}/>
         </div>
}


export function PyhectiqlabDownloadMLModel(){
  const params = [
  { 
    name: "mlmodel_name", 
    type: "str", 
    description: "MLModel name"
  },
  { 
    name: "project", 
    type: "str", 
    description: "Project name"
  },
  { 
    name: "version", 
    type: "str", 
    description: "Specific version of the mlmodel. If <code>None</code>, the latest version is fetched. "
  },
  { 
    name: "save_path", 
    type: "str", 
    default: "./", 
    description: "Save path."
  },
  { 
    name: "overwrite", 
    type: "str", 
    default: "False", 
    description: "Set to <code>True</code> if you want to download the mlmodel again even if it is already saved on your machine."
  }
  ]
  return <div>
          <PythonDoc.Head name="pyhectiqlab.mlmodels.download_mlmodel" params={params}>
Download an existing mlmodel without a run context.
          </PythonDoc.Head>
          <PythonDoc.Params params={params}/>
         </div>
}


export function PyhectiqlabKerasCallback(){
  const params = [
  { 
    name: "run", 
    type: "pyhectiqlab.Run", 
    description: "The target run to host the metrics"
  },
  { 
    name: "level", 
    type: "str", 
    default: "batch",
    description: "Either 'batch' or 'epoch'. If 'batch', the metrics are pushed on every batch and the stepstamp incremented on every batch. If 'epoch', the metrics are pushed every epoch."
  },
  { 
    name: "exclude_train_metrics", 
    type: "bool", 
    default: "False", 
    description: "Set to true to exclude the training metrics."
  },
  { 
    name: "exclude_val_metrics", 
    type: "bool", 
    default: "False", 
    description: "Set to true to exclude the validation metrics."
  },
  { 
    name: "exclude_predict_metrics", 
    type: "bool", 
    default: "False", 
    description: "Set to true to exclude the prediction metrics."
  },
  { 
    name: "exclude_metrics", 
    type: "List[str]", 
    default: "[]", 
    description: "List the metrics to remove from tracking. For validation metrics, add 'val_'. For instance, use `exclude_metrics=['mse', 'val_mse']` to exclude the `mse` metrics in training and validation."
  }
  ]
  return <div>
          <PythonDoc.Head name="pyhectiqlab.callbacks.KerasCallback" params={params}>
            A custom callback object for keras models.
          </PythonDoc.Head>
          <PythonDoc.Params params={params}/>
         </div>
}
